//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Reflux from 'reflux'
import Store from '../../store/store'
import i18 from '../../i18'

class HeaderSteps extends Reflux.Component {

    constructor(props) {
        super();
        this.state = {
            currentStep: props.currentStep,
        };
        this.store = Store;
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            currentStep: nextProps.currentStep
        })
    };

    setStep = (step) => {
        this.props.setStep(step);
    };

    render() {
        return (
            <div className='steps-container'>
                <div className='container'>
                    <div className='row'>
                        <ul className='breadcrumb'>
                            <li className='visited' onClick={(step) => this.setStep(1)}>
                                <a className='visited'>1. {i18.STEPS._upload}</a>
                            </li>
                            <li className={this.state.currentStep > 1 ? 'visited' : ''} onClick={(step) => this.setStep(2)}>
                                <a className={this.state.currentStep > 1 ? 'visited' : ''}>2. {i18.STEPS._accountAssignment}</a>
                            </li>
                            <li className={this.state.currentStep > 2 ? 'visited' : ''}>
                                <a className={this.state.currentStep > 2 ? 'visited' : ''}>3. {i18.STEPS._download}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default HeaderSteps


// WEBPACK FOOTER //
// ./src/components/supplier/headersteps.js